import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})

export class UsersService {

  refreshDetails = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }

  getAll(): any {
    return this.http.get(`${environment.apiUsr}/User/GetAll`);
  }

  saveRecord(data: any) {
    if (data.id) {
      return this.http.put(`${environment.apiUsr}/User/UpdateUser`, data);
    } else {
      return this.http.post(`${environment.apiUsr}/User/CreateUser`, data);
    }
  }

  getDetails(id: number) {
    return this.http.get(`${environment.apiUsr}/User/${id}`);
  }

  getUserProfileDetails() {
    return this.http.get(`${environment.apiUsr}/User/GetUserProfileDetails`);
  }

  deleteRecord(data: any) {
    return this.http.post(`${environment.apiUsr}/User/DeleteUser`, data);
  }

  getUserDefinition() {
    return this.http.get(`${environment.apiUsr}/User/CreateUserDefinition`);
  }

  getUserDefinitionForUpdate(id: number) {
    return this.http.get(`${environment.apiUsr}/User/UserDefinitionForUpdate/${id}`);
  }

  insertOrUpdateUserRoles(data: any) {
    return this.http.post(`${environment.apiUsr}/User/InsertOrUpdateUserRoles`, data);
  }

  getUserSetting() {
    return this.http.get(`${environment.apiUsr}/UserSetting/Get`);
  }

  editUserSetting(data: any) {
    return this.http.post(`${environment.apiUsr}/UserSetting/EditUserSetting`, data);
  }

  uploadUserPicture(avatar: any) {
    return this.http.post(`${environment.apiUsr}/User/UploadUserPicture`, avatar);
  }

  resetUserPass(data: any) {
    return this.http.put(`${environment.apiUsr}/User/ResetUserPass`, data);
  }

  activateUser(id: number) {
    return this.http.post(`${environment.apiUsr}/User/ActivateUser/${id}`, null);
  }

  createfromControlTower(data: any) {
    return this.http.post(`${environment.apiUsr}/User/CreatefromControlTower`, data);
  }

}
